import React, { useContext, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../../css/DynamicSatelliteLoadErrorModal.less';

import DynamicSatelliteService from '../../services/DynamicSatelliteService';

const DynamicSatelliteLoadErrorModal = observer(() => {
  const { dynamicSatelliteManager } = useContext(MobXProviderContext);

  const { showLoadErrorModal } = dynamicSatelliteManager;

  const [isRetrying, setIsRetrying] = useState(false);

  if (!showLoadErrorModal) {
    return null;
  }

  const handleTryAgain = () => {
    if (isRetrying) {
      return;
    }
    setIsRetrying(true);
    DynamicSatelliteService.clearDynamicSatelliteLoadRetryCount();
    window.location.reload();
  };

  return (
    <div
      aria-labelledby='dynamic-satellite-load-error-message'
      aria-modal='true'
      className='dynamic-satellite-load-error-overlay'
      role='alertdialog'>
      <div className='dynamic-satellite-load-error-modal'>
        <p id='dynamic-satellite-load-error-message'>
          Site failed to load, please check your internet connection and try again.
        </p>
        <button
          aria-busy={isRetrying}
          className='dynamic-satellite-load-error-retry'
          disabled={isRetrying}
          onClick={handleTryAgain}
          type='button'>
          {isRetrying && <span className='dynamic-satellite-load-error-spinner' />}
          {isRetrying ? 'Loading...' : 'Try Again'}
        </button>
      </div>
    </div>
  );
});

export default DynamicSatelliteLoadErrorModal;
